
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"12.25"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 168","fill":"#b1b6b9"}},[_c('path',{attrs:{"data-name":"Exclusion 1","d":"M6.999 3.736l3.806 6.66H3.194l3.8-6.659z"}}),_c('path',{attrs:{"data-name":"Path 607 - Outline","d":"M7 2.351l-4.99 8.732h9.98L7 2.351M7 0l7 12.25H0z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/network_module/hierarchy-treeview/closure_drop.svg